import cx from 'classnames'
import React from 'react'

type Props = {
  /** Label to show on the input. */
  label?: string
  /** True if the input field is required */
  isRequired?: boolean
  /** Externally defined className */
  className?: string
  /** On change callback */
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  /** Indicates whether checkbox is checked o not. */
  defaultChecked?: boolean
  /** Test id. */
  'data-testid'?: string
}

/**  Renders a checkbox input. */
const CheckBox: React.FC<
  React.InputHTMLAttributes<HTMLInputElement> & Props
> = ({ label, isRequired, className, defaultChecked, ...rest }) => {
  return (
    <label
      className={cx(
        className,
        'inline-flex items-center text-gray-700 dark:text-gray-400',
      )}
    >
      <input
        type="checkbox"
        className={cx(
          { 'cursor-not-allowed': rest.disabled },
          // TODO: color tokens
          'h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500 focus:ring-offset-background dark:border-gray-600 dark:bg-gray-800',
        )}
        defaultChecked={defaultChecked}
        {...rest}
      />
      {label && <span className="ml-2">{label}</span>}
      {isRequired && <span className="text-red-500">{` *`}</span>}
    </label>
  )
}
CheckBox.displayName = 'CheckBox'
CheckBox.defaultProps = {
  isRequired: false,
}

export default CheckBox
